<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <TypeOfInsulationFormPart @result="onResult" @change="onChange" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import NextStep from '~/pages/quotes-requests/type-de-chauffage'
import TypeOfInsulationFormPart from '~/components/form/parts/typeOfInsulation/TypeOfInsulationFormPart.vue'

export default {
  name: 'TypeOfInsulationFormStep',

  components: {
    TypeOfInsulationFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
